import { render, staticRenderFns } from "./learningAbility.vue?vue&type=template&id=739a5a01&scoped=true&"
import script from "./learningAbility.vue?vue&type=script&lang=js&"
export * from "./learningAbility.vue?vue&type=script&lang=js&"
import style0 from "./learningAbility.vue?vue&type=style&index=0&id=739a5a01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a5a01",
  null
  
)

export default component.exports